import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'

import { getPlaylist as getPlaylistAction } from './playlistActions'
import * as selectors from './playlistSelectors'
import * as shapes from '../../constant/shapes'
import redirectToApp from '../../utils/redirectToApp'
import appConst from '../../constant/appConst'
import TrackList from '../../components/tracklist/TrackList'
import { Link } from 'react-router'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import Loader from '../../components/loader/Loader'
import { Helmet } from 'react-helmet'
import ShareComponent from '../../components/share/ShareComponent'
import ReadMoreComponent from "../../components/ReadMoreComponent"
import GTMController from '../../utils/kpi/GTMController'
import cx from 'classnames'

const fields = [{
	type: 'number',
	render: (track, index) => <span>{index + 1}</span>
},{
	type: 'name',
	render: track => `${track.title}${track.version ? ` (${track.version})` : ''}`
}, {
	type: 'artist',
	render: track => {
		let artistId = ''
		let artistName = ''

		if (track.id) {
			if (track.performer) {
				artistId = track.performer.id
				artistName = track.performer.name
			} else {
				artistId = track.artistId
				artistName = track.artist
			}
		}
		return (<Link to={`/artist/${artistId}`}>{artistName}</Link>)
	}
}, {
	type: 'album',
	render: track => <Link to={`/album/${track.albumId}`}>{track.album}</Link>
}, {
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

const getPlaylistCovers = (images300) => {
	const playlistImages = []
	if (images300) {
		if (images300.length === 3) {
			// on affiche les 3 cover
			let i
			for (i = 0; i < 3; i++) {
				playlistImages.push(images300[i])
			}
		} else {
			// on affiche 4 covers quitte à repeter plusieurs fois les mêmes
			let j
			for (j = 0; j < 4; j++) {
				playlistImages.push(images300[j % images300.length])
			}
		}
	}
	return playlistImages
}

class PlaylistPage extends PureComponent {

	componentWillMount() {
		const { id, getPlaylist } = this.props
		getPlaylist(id)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) {
			this.props.clearPlayqueue()
		}
		if (nextProps.id) {
			GTMController.pushPlaylistPageEvent()
		}
	}

	render() {
		const { id, infos } = this.props
		const { intl } = this.context

		const { duration } = infos

		const showDisplayFull = (infos.description || '').length > appConst.descriptionMaxLength
		let description = ''
		if (infos.description) {
			if (showDisplayFull) {
				const maxPos = infos.description.lastIndexOf(' ', appConst.descriptionMaxLength)
				description = `${infos.description.substring(0, maxPos)}...`
			} else {
				description = infos.description
			}
		}

		let dureeAffichee
		if (duration > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duration/3600)}`, minutes: `${Math.floor((duration % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duration/60)}`, seconds: `${duration % 60}` }
			)
		}

		const playlistImages = getPlaylistCovers(infos.images)
		const playlistSpecialImage = infos.image_rectangle
		let cssForCover
		if (playlistSpecialImage) {
			cssForCover = '--special'
		} else {
			cssForCover = playlistImages.length > 0 ? `--cover-${playlistImages.length}` : '--empty pct pct-nav-playlist'
		}

		return (
			<Loader>
				<div className="page page--playlist">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.playlist" }, { playlistName: infos.name, ownerName: infos.owner })}</title>
					</Helmet>
					<div className="page__background page__background--playlist">
						{playlistSpecialImage ?
							<div
								className="page__image page__image--special"
								key="background-playlist-item"
								style={{ backgroundImage: `url(${playlistSpecialImage})` }}
							/>
						: playlistImages.map((image, i) =>
							<div className="page__image" key={`background-playlist-item-${i}`} style={{ backgroundImage: `url(${image})` }} />
						)}
					</div>

					<div className="page__container">

						{/* HEADING BLOC */}
						<div className="heading">
							<div className={`heading__cover heading__cover--playlist heading__cover--playlist${cssForCover}`}>
								{playlistSpecialImage ?
									<span
										className="heading__image"
										key="user-playlist-cover-small"
										style={{ backgroundImage: `url(${playlistSpecialImage})` }}
									/>
								: playlistImages.map((image, i) =>
									<span
										className="heading__image"
										key={`user-playlist-cover-small-${i}`}
										style={{ backgroundImage: `url(${image})` }}
									/>
								)}
							</div>
							<div className="heading__container heading__container--playlist">
								<h1 className="heading__title heading__title--playlist">{infos.name}</h1>
								<p className="heading__infos heading__infos--playlist">
									{intl.formatMessage({ id: 'focus.from' }, { author: infos.owner })}
								</p>
								<div className="heading__buttons">
									<a
										className="heading__button pct pct-play"
										onClick={() => {
											GTMController.pushEvent(GTMController.EVENTS.PLAYLIST_PLAY)
											redirectToApp('playlist', id)
										}}
									>
										{intl.formatMessage({ id: 'buttons.listen' })}
									</a>
									<ShareComponent GTMCopyEvent={GTMController.EVENTS.PLAYLIST_SHARE}/>
								</div>
							</div>
						</div>

						{/* INFOS BLOC */}
						<div className="infos infos--playlist">
							<h2 className="infos__title">{intl.formatMessage({ id: 'aside.title' })}</h2>
							{infos.genres && infos.genres.length ? <p className="infos__subtitle">{infos.genres.map(genreId => intl.formatMessage({ id: `genre.genre-id-${genreId}` })).join(' / ')}</p> : ''}
							<p className="infos__track">
								{intl.formatMessage({ id: 'infos.trackCount' }, { count: `${infos.tracksCount}` })} - {dureeAffichee}
							</p>
							<div className={cx('infos__container', { 'infos__container--long': showDisplayFull})}>
								<p {...{ className: 'infos__excerpt' }}
									dangerouslySetInnerHTML={{ __html: (description ? `${description}` : '').nl2br() }}
								/>
								<ReadMoreComponent id={id} type={"playlist"} />
							</div>
						</div>

						{/* TRACKLIST BLOC */}
						<div className="tracklist">
							<h2 className="tracklist__title">{intl.formatMessage({ id: 'tracklist.title.playlist' })}</h2>
							<TrackList
								fields={fields}
								listContainerClassName="tracklist__container tracklist__container--playlist"
								GTMPlayEvent={GTMController.EVENTS.PLAYLIST_TRACK_PLAY}
								listClassName="tracklist__tracks"
							/>
							{
								infos.total > infos.limit &&
								<button
									className="tracklist__button tracklist__button--playlist pct pct-add"
									onClick={() => redirectToApp('playlist', infos.id)}
								>
									{intl.formatMessage({ id: 'buttons.moreplaylisttrack' })}
								</button>
							}
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

PlaylistPage.propTypes = {
	id: PropTypes.string,
	infos: shapes.playlist,
	getPlaylist: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

PlaylistPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	infos: selectors.getPlaylistInfos(state)
})

const actions = {
	getPlaylist: getPlaylistAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(PlaylistPage)



// WEBPACK FOOTER //
// ./src/pages/playlist/PlaylistPage.jsx